import React, { useContext } from 'react';

export type HomeContextProps = {
    accountDetailSSO: (url: string) => Promise<void>;
    onLogoutEvent: () => void;
};
export const HomeContext = React.createContext<HomeContextProps | null>(null);
export const useHomeContext = () => useContext(HomeContext);
